import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import logo from '../assets/logo-sobredigital.png';


const Logo = ({ className = "" }) => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleLogoClick = (e) => {
    e.preventDefault();
    
    if (user) {
      // If logged in, go to their dashboard
      if (user.role === 'admin') {
        navigate('/admin');
      } else {
        navigate('/mi-cuenta');
      }
    } else {
      // If not logged in, go to home
      navigate('/');
    }
  };

  return (
    <a href="/" onClick={handleLogoClick}   className={`flex items-center ${className}`}
>
      {/* <span className="text-3xl">💝</span>
      <span className="text-2xl font-script font-bold text-accent-600">
        SobreDigital
      </span> */}
      <img
  src={logo}
  alt="SobreDigital"
  className="block h-full w-auto max-h-full"
/>

    </a>
  );
};

export default Logo;
